import { Link } from "react-router-dom";

export default function PaymentSuccess() {
  return (
    <section className="min-h-screen flex items-center justify-center px-6" data-testid="payment-success">
      <div className="max-w-lg text-center">
        <p className="text-[11px] tracking-[0.3em] text-[#A4801C] mb-6">CONFIRMATION</p>
        <h1 className="font-display text-5xl md:text-6xl font-light leading-none mb-6">Thank you.</h1>
        <p className="text-[#0A0A14]/70 mb-10">Your payment is confirmed. A member of the Metamorphosis team will reach out shortly.</p>
        <Link to="/" className="btn-editorial" data-testid="back-home">Return home <span className="arrow">→</span></Link>
      </div>
    </section>
  );
}
